import { Initialization, Logout } from '@mit/aws-react'
import { HuiThemeProvider } from '@mit/hui-core'
import appConfig from 'app-config-global'
import { useAppInitializer } from 'hooks/Initializer'
import { useRouting } from 'hooks/Routing'
import React, { FC } from 'react'
import ReactDOM from 'react-dom'
import { Helmet } from 'react-helmet'
import { Provider, useSelector } from 'react-redux'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'scss/main.scss'
import { RootState, store } from 'store'
import reportWebVitals from './reportWebVitals'

const App = React.lazy(async () => await import('components/app/App').then(module => ({ default: module.App })))

const WrappedApp: FC = () => {
  const { appContact, appDescription, appName } = useSelector((state: RootState) => state.appConfig)
  const { initializeApp } = useAppInitializer()

  useRouting()

  return (
    <>
      <ToastContainer hideProgressBar theme='colored' />
      <Helmet titleTemplate={`${appName} - %s`} defaultTitle={appName}>
        <meta name='description' content={appDescription} />
      </Helmet>
      <React.StrictMode>
        <Routes>
          <Route path='/logout' element={<Logout />} />
          <Route
            path='*'
            element={
              <Initialization
                App={App}
                appInitializer={initializeApp}
                appConfigData={appConfig}
                loaderProps={{
                  contactEmail: appContact,
                  name: appName,
                  type: 'Default',
                  isLoading: true
                }}
              />
            }
          />
        </Routes>
      </React.StrictMode>
    </>
  )
}

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <HuiThemeProvider variant='default'>
        <WrappedApp />
      </HuiThemeProvider>
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
